module.exports = __webpack_public_path__ + "img/phone.ade718a3.png";